<script setup lang="ts"></script>

<template>
  <div class="loading-wrapper">
    <div class="loading-frame">
      <i class="car mi-outlined mi-airport-shuttle" />
      <div class="line" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use 'sass:map';
@use 'frontend_stylesheets/theme-variables' as themeVariables;

.loading-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.loading-frame {
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(var(--spinner-size, 48px) * 1.2);
  height: var(--spinner-size, 48px);
  overflow: hidden;
  position: relative;
}

.car {
  font-size: calc(var(--spinner-size, 42px) * 0.85);
  animation: car-forward 2s infinite ease-in-out;
  color: map.get(themeVariables.$colors, primary);
}

.line {
  position: absolute;
  height: 2px;
  background-image: linear-gradient(
    to right,
    map.get(themeVariables.$colors, onSurfaceVariant) 0%,
    map.get(themeVariables.$colors, onSurfaceVariant) 12.5%,
    transparent 12.5%,
    transparent 25%,
    map.get(themeVariables.$colors, onSurfaceVariant) 25%,
    map.get(themeVariables.$colors, onSurfaceVariant) 37.5%,
    transparent 37.5%,
    transparent 50%,
    map.get(themeVariables.$colors, onSurfaceVariant) 50%,
    map.get(themeVariables.$colors, onSurfaceVariant) 62.5%,
    transparent 62.5%,
    transparent 75%,
    map.get(themeVariables.$colors, onSurfaceVariant) 75%,
    map.get(themeVariables.$colors, onSurfaceVariant) 87.5%,
    transparent 87.5%,
    transparent 100%
  );
  width: 200%;
  bottom: 0;
  left: 0;
  animation: move 0.5s infinite linear;
}

@keyframes move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes car-forward {
  0% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(5px) rotate(-2deg);
  }
  100% {
    transform: translateX(0);
  }
}
</style>
